import axios from '../utils/request';

export const getUserDetail = () => axios.get('/user');

export const getOrders = ({ page = 1, status }) => {
  const isPublic = window.sessionStorage.getItem('spotId') === '0';
  if (isPublic) return axios.get('/admincode', { params: { page, status } });
  return axios.get('/code', {
    params: {
      page,
      status,
    },
  });
};

export const createOrder = ({ id, tel, date, info, count, reserve, ticketTypeId }, united) => {
  const isPublic = window.sessionStorage.getItem('spotId') === '0';
  if (isPublic)
    return axios.post('/adminpay', {
      tel,
      info,
      cid: united ? undefined : id,
      ticket_joint_id: united ? id : undefined,
      use_date: date,
      ticket_type_id: ticketTypeId,
      start_time: reserve.start_time,
      end_time: reserve.end_time,
      totalNum: count,
    });
  return axios.post('/pay', {
    tel,
    info,
    cid: id,
    ticket_type_id: ticketTypeId,
    start_time: reserve.start_time,
    end_time: reserve.end_time,
    use_date: date,
    totalNum: count,
  });
};

export const updateOrder = ({ orderid, paychannel }) => axios.post('/pay', { orderid, paychannel });

export const createRefund = ({ code, spotId }) => {
  const isPublic = window.sessionStorage.getItem('spotId') === '0';
  if (isPublic) return axios.post('/adminrefund', { code, spot_id: spotId });
  return axios.post('/refund', {
    code,
  });
};

export const getUserOpenid = () => axios.get('/getopenid');

export const getUserAgencyStatus = ({ openid } = {}) =>
  axios.get('/gettravel', { params: { openid } });
